
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  resizeImage(
    image: File,
    maxWidth: number,
    maxHeight: number,
    options?: { outputType?: string; quality?: number },
  ): Promise<File> {
    return new Promise((resolve, reject) => {
      const canvas = this.document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.onerror = () => reject(new Error('Failed to load image for resize'));
      
      img.onload = () => {
        // Calculate new dimensions while maintaining aspect ratio
       
        let { width, height } = img;
        
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }
        
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height;
        
        // Draw resized image
        ctx?.drawImage(img, 0, 0, width, height);
        
        // Convert canvas to blob
        const outputType = options?.outputType ?? image.type;
        const quality = options?.quality ?? 0.8;

        canvas.toBlob((blob) => {
          if (blob) {
            // Create new file with resized image
            const resizedFile = new File([blob], image.name, {
              type: outputType,
              lastModified: Date.now()
            });
            resolve(resizedFile);
          } else {
            reject(new Error('Failed to resize image (canvas.toBlob returned null)'));
          }
        }, outputType, quality); // quality for balance of size and quality

        URL.revokeObjectURL(img.src)
      };

      img.src = URL.createObjectURL(image);
    });
  }


  resizeImageBlob(
    image: Blob,
    maxWidth: number,
    maxHeight: number,
    options?: { outputType?: string; quality?: number },
  ): Promise<Blob> {
    return new Promise((resolve, reject) => {
      const canvas = this.document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.onerror = () => reject(new Error('Failed to load image blob for resize'));
      
      img.onload = () => {
        // Calculate new dimensions while maintaining aspect ratio
       
        let { width, height } = img;
        
        if (width > height) {
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = (width * maxHeight) / height;
            height = maxHeight;
          }
        }
        
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height;
        
        // Draw resized image
        ctx?.drawImage(img, 0, 0, width, height);
        
        // Convert canvas to blob
        const outputType = options?.outputType ?? image.type;
        const quality = options?.quality ?? 0.8;

        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Failed to resize image (canvas.toBlob returned null)'));
          }
        }, outputType, quality); // quality for balance of size and quality

        URL.revokeObjectURL(img.src)
      };

      img.src = URL.createObjectURL(image);
    });
  }

}